import store from "@/store";
import instance from "./utils/Http";
import router from "./router";

export const normalizeComma = (input) => {
  if (input == null) return ""; // null / undefined
  if (typeof input !== "string") {
    input = String(input); // 兜底转字符串
  }

  return input
    .replace(/，/g, ",") // 中文逗号 → 英文逗号
    .replace(/\s*,\s*/g, ",") // 逗号两边去空格
    .replace(/,+/g, ",") // 多个逗号合并
    .replace(/^,|,$/g, ""); // 去掉首尾逗号
};

export const checkExcluded = (
  excludedWebType,
  excludedWeb,
  excludedAuthorType,
  excludedAuthor
) => {
  var webList = excludedWeb;
  var authorList = excludedAuthor

  // 都是模糊
  if (excludedWebType == 1 && excludedAuthorType == 1) {
    return webList.length + authorList.length <= 5;
  }

  // 其他情况：分别判断
  return webList.length <= 5 && authorList.length <= 5;
};
export const getWordLength = (word) => {
  // 匹配规则：
  // [\u4e00-\u9fa5] —— 单个汉字
  // [a-zA-Z0-9]+ —— 连续的字母或数字
  // [^\u4e00-\u9fa5a-zA-Z0-9]+ —— 其他符号连续串
  const parts = word.match(
    /[\u4e00-\u9fa5]|[a-zA-Z0-9]+|[^\u4e00-\u9fa5a-zA-Z0-9]+/g
  );
  return parts ? parts.length : 0;
};
export const calcTotalLength = (data) => {
  let total = 0;
  for (const group of data) {
    const lists = [
      ...group.keywordList,
      ...group.optionalKeywordList,
      ...group.excludeKeywordList,
    ];
    for (const word of lists) {
      total += getWordLength(word);
    }
  }
  return total;
};
export const getLocalTime = (nS) => {
  let date = new Date(nS); //如果date为13位不需要乘1000
  let Y = date.getFullYear() + "-";
  let M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "";
  let h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  let m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return Y + M + D;
};
export function getBeforeDate(n) {
  //根据n的值获取当前日期前几天的日期,n==0今天 n==1昨天
  var n = n;
  var d = new Date();
  var year = d.getFullYear();
  var mon = d.getMonth() + 1;
  var day = d.getDate();
  if (day <= n) {
    if (mon > 1) {
      mon = mon - 1;
    } else {
      year = year - 1;
      mon = 12;
    }
  }
  d.setDate(d.getDate() - n);
  year = d.getFullYear();
  mon = d.getMonth() + 1;
  day = d.getDate();
  var s =
    year +
    "-" +
    (mon < 10 ? "0" + mon : mon) +
    "-" +
    (day < 10 ? "0" + day : day);
  return s;
}
/**
 * 输入时间秒，转换为时:分:秒
 * @param {Object} value秒
 */
export function formatTime(value) {
  if (value === "" || value == null) {
    return "";
  } else {
    var seconds = parseInt(value / 1000), // 秒
      minutes = 0, // 分
      hours = 0, // 小时
      result;
    hours = parseInt(seconds / 3600); //转换小时
    hours = hours > 9 ? hours : "0" + hours;
    minutes = parseInt(seconds / 60) - hours * 60; //转换分钟
    minutes = minutes > 9 ? minutes : "0" + minutes;
    seconds = seconds % 60;
    seconds = seconds > 9 ? seconds : "0" + seconds;
    result = hours + ":" + minutes + ":" + seconds;
    return result;
  }
}
export function formatTime2HMSMs(time) {
  if (time === "" || time == null) {
    return "";
  } else {
    const millisecond = parseInt(
      time
        .toString()
        .substring(time.toString().length - 3, time.toString().length)
    );
    let second = 0;
    let totalMinute = 0;
    let minute = 0;
    let hour = 0;
    let result = "";
    const totalSecond = parseInt(time / 1000); // 3671
    if (totalSecond > 59) {
      // 总秒数大于59 需要计算总分钟 数
      second = parseInt(totalSecond % 60); // 11
      totalMinute = parseInt(totalSecond / 60); // 61
    } else {
      second = totalSecond;
    }
    if (totalMinute > 59) {
      minute = parseInt(totalMinute % 60); // 1
      hour = parseInt(totalMinute / 60); // 1
    } else {
      minute = totalMinute;
    }
    if (hour < 10) {
      result += "0" + hour;
    } else {
      result += "" + hour;
    }
    if (minute < 10) {
      result += ":0" + minute;
    } else {
      result += ":" + minute;
    }
    if (second < 10) {
      result += ":0" + second;
    } else {
      result += ":" + second;
    }
    if (millisecond < 10) {
      result += ".00" + millisecond;
    } else if (millisecond < 100) {
      result += ".0" + millisecond;
    } else {
      result += "." + millisecond;
    }
    return result;
  }
}

export function _isMobile() {
  let flag = navigator.userAgent.match(
    /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
  );
  return flag;
}

export async function permissionPage() {
  // ① 如果 Vuex 里已经有权限，直接返回
  if (
    Array.isArray(store.state.permissions) &&
    store.state.permissions.length > 0
  ) {
    return store.state.permissions;
  }

  // ② 刷新后 Vuex 肯定是空的 → 走接口逻辑
  const id = window.localStorage.getItem("id");
  if (!id) {
    router.push("/login");
    return [];
  }

  const res = await instance.get(
    `${store.state.serverUrl}search/user/userMenuSelect?userId=${id}`
  );

  if (res.data.code === 0) {
    const data = res.data.data;
    // 存 Vuex（刷新后菜单等地方可用）
    store.commit("setPermissions", data);
    // 你愿意存本地就存，不愿意就删掉
    window.localStorage.setItem("permissions", JSON.stringify(data));

    return data;
  } else {
    return [];
  }
}

export default {
  getLocalTime,
  getBeforeDate,
  formatTime,
  formatTime2HMSMs,
  _isMobile,
  getWordLength,
  calcTotalLength,
  permissionPage,
};
